import React from 'react';
interface ProgressBarProps {
  progress: number; // 0 to 100
  className?: string;
}
/**
 * Inline progress bar — render it as the top edge of a card.
 * Parent should be `relative` with `overflow-hidden` so the fill clips to rounded corners.
 */
export function ProgressBar({
  progress,
  className = ''
}: ProgressBarProps) {
  return <div className={`absolute top-0 left-0 right-0 h-[3px] bg-line z-10 ${className}`} data-id="element-111">
      <div className="h-full bg-orange transition-all duration-500 ease-out" style={{
      width: `${Math.min(Math.max(progress, 0), 100)}%`
    }} data-id="element-112" />
    </div>;
}